import { render, staticRenderFns } from "./MonerisCheckout.vue?vue&type=template&id=79b21fd3&scoped=true"
import script from "./MonerisCheckout.vue?vue&type=script&lang=js"
export * from "./MonerisCheckout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b21fd3",
  null
  
)

export default component.exports